$(function($){

  'use strict';

  CartJS.getCart();

  var _pc = window._pc || {};

  var _updateItem = async (line, quantity) => {
    const cartData = JSON.parse(JSON.stringify(CartJS.cart))
    if (!cartData?.items?.length) return cartData

    const lineItem = cartData.items[line - 1];
    if (lineItem?.properties && !!lineItem.properties['_bundle_group']?.length) {
      return cartData
    }

    return await CartJS.updateItem(line, quantity);
  }

_pc.set = function() {

  $('[data-mh]').matchHeight();
  $('[data-mhnr]').matchHeight({byRow: false});

  $('.three-cols .three-col .col-img').matchHeight();


  if($('[data-nav]').length) {
    var navColor = $('[data-nav]').attr('data-nav');

    if(navColor == 'navcolblue') {
      $('body').addClass('header-dark').removeClass('header-trans');
    } else if(navColor == 'navcoldefault') {
      $('body').removeClass('header-trans');
    }

    if(navColor == 'navcolwhite') {
      $('body').addClass('header-trans');
    }

  }

  window.setTimeout(function () {
    $('.main-header').addClass('header-ready');
  }, 500);


};

_pc.scrolls = function() {

  // NEXT OR FIRST
  $.fn.nextOrFirst = function(selector) {
    var next = this.next(selector);
    return (next.length) ? next : this.prevAll(selector).last();
  };

  // SCROLL TO NEXT
  $('[data-scroll="next"]').on('click', function (e) {
    e.preventDefault();
    $.scrollTo($(this).closest('section').next(), {
      axis : 'y',
      offset : 0,
      duration : 600
    });
  });

  // SCROLL TO HASH
  $('[data-scroll="hash"]').on('click', function (e) {
    e.preventDefault();

    var offset = 0;

    if ($(this).attr("data-offset")) {
      offset = $(this).data('offset');
    }

    if ($(this).attr("data-offset-mobile") && window.innerWidth < 768) {
      offset = $(this).data('offset-mobile');
    }

    $.scrollTo(this.hash, {
      axis : 'y',
      offset : offset,
      duration : 600
    });
  });

  // SCROLL TO TOP
  $('[data-scroll="top"]').click(function() {
    $("html, body").animate({ scrollTop: 0 });
    return false;
  });

  $(window).on("load scroll",function(e){
    var $this = $(this);
    var headerHt = $('#site-header').outerHeight();
    var aspotHeight = $('#aspot').outerHeight();

    if ($this.scrollTop() > headerHt) {
      $("body").addClass('passed-header');
    } else {
      $("body").removeClass('passed-header');
    }
    if ($this.scrollTop() > headerHt*2) {
      $("body").addClass('ready-header');
    } else {
      $("body").removeClass('ready-header');
    }
    if ($this.scrollTop() > aspotHeight) {
      $("body").addClass('passed-aspot');
    } else {
      $("body").removeClass('passed-aspot');
    }
    if ($this.scrollTop() > 0) {
      $("body").addClass('has-scrolled');
    } else {
      $("body").removeClass('has-scrolled');
    }
  });

};

_pc.toggleNav = function(){

  $('[data-toggle="mobile-navigation"]').on('click', function (e) {
    e.preventDefault();
    if ( $(this).hasClass('toggled') ) {
      closeNav();
    } else {
      openNav();
    }
  });

  function openNav() {
    $('#mobile-navigation').addClass('is-visible');
    $('[data-toggle="mobile-navigation"]').addClass('toggled');
    $('body').addClass('show-nav');
    $('body').addClass('js-no-scroll');
  }

  function closeNav() {
    $('#mobile-navigation').removeClass('is-visible');
    $('[data-toggle="mobile-navigation"]').removeClass('toggled');
    $('body').removeClass('show-nav');
    $('body').removeClass('js-no-scroll');
  }



  $('#mobile-navigation .has-drop .droptoggle').on('click', function (e) {
    e.preventDefault();

      if($(this).parents('li').hasClass('drp-open')) {
        $(this).parents('a').next('.drpdwn').slideUp(250,'swing');
        $(this).parents('li').removeClass('drp-open');
      } else {
        $(this).parents('li').siblings('.has-drop').find('.drpdwn').slideUp(250,'swing');
        $(this).parents('li').siblings('.has-drop').removeClass('drp-open');
        $(this).parents('a').next('.drpdwn').slideDown(250,'swing');
        $(this).parents('li').addClass('drp-open');
      }

  });

};

_pc.slick = function(){

  $('[data-slick]').slick({
    lazyLoad: 'progressive',
    fade: true,
    speed: 400,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          // arrows: false,
          fade: false,
          speed: 300,
        }
      }
    ]
  });

  $('.section-products-slider:not(.section-products-slider--redesign) .products-slider:not(.rel-products-slider)').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    appendArrows: '.prodslider-arrows',
    prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
    nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
    centerMode: false,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });


  $('.section-products-slider .products-slider:not(.rel-products-slider)').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.section-products-slider .products-slider:not(.rel-products-slider)').on('afterChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });



  $('.section-products-slider .rel-products-slider').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    appendArrows: '.prodslider-arrows',
    prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
    nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
    centerMode: false,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });


  $('.section-products-slider .rel-products-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.section-products-slider .rel-products-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.section-products-slider--redesign .products-slider--redesign').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    appendArrows: '.prodslider-arrows',
    prevArrow: '<button class="slide-prev"></button>',
    nextArrow: '<button class="slide-next"></button>',
    centerMode: false,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.section-products-slider--redesign .products-slider--redesign').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.section-products-slider--redesign .products-slider--redesign').on('afterChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.slide-slider').not('.slick-initialized').each(function () {
    const numberOfSlides = $(this).find('.slide-slider-slide').length;
    $(this).slick({
      fade: false,
      speed: 400,
      cssEase: 'ease-out',
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: numberOfSlides > 1,
      // appendArrows: '.slider-arrows',
      prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
      nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
      centerMode: true,
      centerPadding: '0',
      autoplay: false,
      pauseOnHover: true,
      touchThreshold: 20
    });
  });


  $(".slide-slider .slick-arrow").click(function(e){
    e.preventDefault();
  });

  $('.section-insta-slider .insta-slider').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'linear',
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    appendArrows: '.instslider-arrows',
    prevArrow: '<button class="slide-prev"></button>',
    nextArrow: '<button class="slide-next"></button>',
    centerMode: true,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });


  $('.section-reviews-slider .reviews-slider').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    appendArrows: '.revslider-arrows',
    prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
    nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
    centerMode: true,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });


  $('#revived .revived-slider').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    appendArrows: '.revived-arrows',
    prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
    nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
    centerMode: true,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('#revived .revived-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('#revived .revived-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.hero-slider').not('.slick-initialized').each(function () {
    const $slider = $(this);
    const autoplay = $slider.data('autoplay') === true || $slider.data('autoplay') === 'true';
    const autoplaySpeed = parseInt($slider.data('autoplay-speed'), 10) || 3000;

    $slider.slick({
      fade: false,
      speed: 400,
      cssEase: 'ease-out',
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      appendArrows: '.heroslider-arrows',
      prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
      nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
      // centerMode: false,
      // centerPadding: '0',
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      pauseOnHover: true,
      touchThreshold: 20
    });
  });

  $('.hero-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.hero-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });




  $('.hiw-slider').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    appendArrows: '.hiwslider-arrows',
    prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
    nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
    centerMode: true,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20
  });




  $('.cart-mini .rec-products-slider').not('.slick-initialized').slick({
    fade: false,
    speed: 400,
    cssEase: 'ease-out',
    dots: false,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    prevArrow: '<button class="slide-prev"><i class="_icon-chev-left"></i></button>',
    nextArrow: '<button class="slide-next"><i class="_icon-chev-right"></i></button>',
    centerMode: false,
    centerPadding: '0',
    autoplay: false,
    pauseOnHover: true,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          arrows: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: true,
          appendArrows: '.prodslider-arrows'
        }
      }
    ]
  });


  $('.cart-mini .rec-products-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

  $('.cart-mini .rec-products-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    bLazy.revalidate();
  });

};

_pc.accordion = function(){

  if($('.accordion:not(.has-buddies)').length) {

    $('.accordion-wrap').first().addClass('info-active');
    $('.accordion-wrap').first().find('.info-answer').slideDown(250,'swing');

    $('.accordion-wrap').click(function(e) {
      e.preventDefault();

      if($(this).hasClass('info-active')) {
        $(this).find('.info-answer').slideUp(250,'swing');
        $(this).removeClass('info-active');
      } else {
        $(this).siblings('.accordion-wrap').find('.info-answer').slideUp(250,'swing');
        $(this).siblings('.accordion-wrap').removeClass('info-active');
        $(this).find('.info-answer').slideDown(250,'swing');
        $(this).addClass('info-active');
      }


    });

    $('.accordion-wrap a').click(function(e) {
      e.stopPropagation();
    });

  }


  if($('.accordion.has-buddies').length) {

    $('.accordion-wrap').first().addClass('info-active');
    $('.accordion-wrap').first().find('.info-answer').slideDown(250,'swing');

    window.setTimeout(function () {

      var maxHeight = $('.acc-buddies .acc-buddy.active').outerHeight();

      $('.acc-buddies').css('height', maxHeight+'px');

    }, 1500);


    $(window).on("resize",function(e){

      var maxHeight = $('.acc-buddies .acc-buddy.active').outerHeight();

      $('.acc-buddies').css('height', maxHeight+'px');

    });


    $('.accordion-wrap').click(function(e) {
      e.preventDefault();

      var buddy = $(this).attr('data-buddy');

      if($(this).hasClass('info-active')) {
        // $(this).find('.info-answer').slideUp(250,'swing');
        // $(this).removeClass('info-active');

        // $('.acc-buddy#'+buddy).removeClass('active');

        // $('.acc-buddies').css('height', 'auto');

      } else {
        $(this).siblings('.accordion-wrap').find('.info-answer').slideUp(250,'swing');
        $(this).siblings('.accordion-wrap').removeClass('info-active');
        $(this).find('.info-answer').slideDown(250,'swing');
        $(this).addClass('info-active');

        var maxHeight = $('.acc-buddy#'+buddy).outerHeight();

        $('.acc-buddies').css('height', maxHeight+'px');

        $('.acc-buddy#'+buddy).siblings('.acc-buddy').removeClass('active');
        $('.acc-buddy#'+buddy).addClass('active');
      }



    });

    $('.accordion-wrap a').click(function(e) {
      e.stopPropagation();
    });

  }


  $('.accordion-wrap .inner p > a[title="chevlink"]').addClass('chevlink').append('<i></i>');

};

_pc.scrollMagic = function() {


  if($('#how-it-works').length) {
    window.setTimeout(function () {

      var controller = new ScrollMagic.Controller();

	  var brwsrHt = $(window).height();
      var sectHt = $('#how-it-works').outerHeight();
      var introHt = $('.hiw-intro-wrap').outerHeight();
      var contHt = $('.hiw-intro-cont').outerHeight();
      var newSectHt = sectHt - contHt;

      var offsetHt = ((brwsrHt / 2) - contHt) * -1;
      var newSectHt = (newSectHt - introHt) - 80;

      var scene = new ScrollMagic.Scene({
        triggerElement: '#how-it-works',
        offset: offsetHt,
        triggerHook: 0,
        duration: newSectHt,
        reverse: true
      })
      .setClassToggle('.hiw-desc-wrap', 'is-inside')
      .setPin('.hiw-intro-cont')
      .addTo(controller);

      $('.hiw-img').each(function(index) {
        var introHt = $('.hiw-intro-wrap').outerHeight();
        var introHt = introHt + 40;
        var imgHt = $(this).outerHeight();
        var imgRow = $(this).attr('data-hiwimg');

        var imgScene = new ScrollMagic.Scene({
          triggerElement: this,
          offset: offsetHt,
          triggerHook: 0,
          duration: imgHt,
          reverse: true
        })
        .setClassToggle('.hiwdesc-'+imgRow, 'active')
        .addTo(controller);

      });

    }, 750);
  }


  if($('[data-page="product"]').length) {
    var imgscontroll;
    var winwidth = $(window).width();

    window.setTimeout(function () {

      function initScrollMagic(){

        imgscontroll = new ScrollMagic.Controller();

        var sectHt = $('.product-details-wrapper--v3').outerHeight();
        var contHt = $('.product-area--v3').outerHeight();
        var newSectHt = contHt - sectHt;

        var scene = new ScrollMagic.Scene({
          triggerElement: '.product-area--v3',
          offset: -30,
          triggerHook: 0,
          duration: newSectHt,
          reverse: true
        })
        .setPin('.product-details-wrapper--v3')
        .addTo(imgscontroll);

      }

      if( winwidth > 767) {
        initScrollMagic()
      }

      $(window).resize(function(){
        winwidth = $(window).width()

        if( winwidth < 768 ) {
          if (imgscontroll) {
            imgscontrol2 = imgscontroll.destroy(true);
          }
        } else if ( winwidth > 767 ) {
          if ( !imgscontroll ) {
            initScrollMagic()
          }
        }

      });

    }, 2000);

  }


};

_pc.dropLists = function(){

  drops();

  function drops() {

    $('.drop-wrap').each(function(index) {

      var drWrap = $(this);
      var toDrop = $(this).find('.drop-list');
      var drButton = $(this).find('.drop-button');
      var wrapper = $(this).find('ul');
      var initActiveAnchor = toDrop.find('li.active a');
      var initActiveCollection = initActiveAnchor.attr('data-collection');
      $('.collection-content').hide();
      $('.collection-content#comp_'+initActiveCollection).show();

      // DROP LINK CLICK
      $(drButton).click(function(e) {
        e.preventDefault();

        if ( $(drWrap).hasClass('is-dropped') ) {
          $(drWrap).removeClass('is-dropped');
          $(toDrop).removeClass('is-visible');
          $(toDrop).slideUp(250);
        } else {
          $('.drop-wrap.is-dropped .drop-list').slideUp(250);
          $('.drop-wrap.is-dropped .drop-list').removeClass('is-visible');
          $('.drop-wrap.is-dropped').removeClass('is-dropped');

          $(drWrap).addClass('is-dropped');

          $(toDrop).slideDown(250, function(e) {
            $(toDrop).addClass('is-visible');
          });
        }

      });

      // LIST LINK CLICK
      $(wrapper).find('a').click(function(e) {
        e.preventDefault();

        var toOpen = $(this).attr('data-collection');

        var linkText = $(this).find('span').text();
        var linkLi = $(this).parents('li');

        if (linkText.indexOf("Any") >= 0) {
          linkText = linkText.replace('Any ', '');
        }

        if (linkText.indexOf("All") >= 0) {
          linkText = linkText.replace('All ', '');
        }

        $(drButton).find('span').text(linkText);

        $(drWrap).removeClass('is-dropped');
        $(toDrop).removeClass('is-visible');
        $(toDrop).slideUp(250, function(e) {
          $(wrapper).find('li.active').removeClass('active');
          $(linkLi).addClass('active');
        });

        $('.collection-content').hide();
        $('.collection-content#comp_'+toOpen).show();

        window.setTimeout(function () {
          $('.slide-slider').slick('reinit');
        }, 200);
      });

    });

  }

  $(document).click(function(event){
    if ( !$(event.target).closest('.drop-wrap').length ) {
      $('.is-dropped').removeClass('is-dropped');
      $('.drop-list').removeClass('is-visible');
      $('.drop-list').slideUp(250);
    }
  });
};

_pc.formStuff = function() {

  $('.field-wrap input.error').parents('.field-wrap').addClass('has-error');

  $('.select-field').each(function(index) {
    $(this).append('<i></i>');
  });

  $('.select-field select').on('focus', function() {
    $(this).parents('.select-field').addClass('is-focused');
  }).on('blur', function() {
    $(this).parents('.select-field').removeClass('is-focused');
  }).on('change', function() {
    $(this).parents('.select-field').removeClass('is-focused');
  });


  $('.select-field select').on('mousedown', function(){
    $(this).parents('.select-field').toggleClass('is-focused');
  }).on('mouseup', function(){
    $(this).parents('.select-field').toggleClass('is-focused');
  }).on('click', function(){
    $(this).parents('.select-field').toggleClass('is-focused');
  });


  if($('#contact_form').length) {
    $("#contact-phone").usPhoneFormat();
  }

  if($('.buyback-form').length) {

    $('.buyback-form #contact-product').change(function(){

      var theVal = $(this).val();

      if(theVal == "essential-sectional" || theVal == "essential-sofa" || theVal == "essential-loveseat") {
        $('.fabric-details').show();
        $('.leg-details').show();
      }

      if(theVal == "essential-ottoman") {
        $('.cushion-details').show();
      } else {
        $('.cushion-details').hide();
      }

    });

  }

};

_pc.misc = function() {
  window.setTimeout(function () {
    if($('.spr-badge').length) {
        $('.spr-badge').hide();
        var revRat = $('.spr-badge').attr('data-rating');
        var revAmt = $('.spr-badge-caption').text();
        var revAmt = revAmt.substr(0,revAmt.indexOf(' '));
      	var revRat = Math.round(revRat * 10).toFixed(1) / 10;

        if( revAmt >= 1) {
          $('.prod-review-info').show();
        }

        if(revRat >= 4.5) {
          $('.prod-review-info .rev-stars').addClass('show-5');
        } else if(revRat >= 3.5 && revRat < 4.5) {
          $('.prod-review-info .rev-stars').addClass('show-4');
        } else if(revRat >= 2.5 && revRat < 3.5) {
          $('.prod-review-info .rev-stars').addClass('show-3');
        } else if(revRat >= 1.5 && revRat < 2.5) {
          $('.prod-review-info .rev-stars').addClass('show-2');
        } else if(revRat >= 0.5 && revRat < 1.5) {
          $('.prod-review-info .rev-stars').addClass('show-1');
        } else {
          $('.prod-review-info .rev-stars').addClass('show-0');
        }

        $('.prod-review-info .rev-rating').text(revRat);

        if(revAmt > 1) {
          $('.prod-review-info .rev-amount a').prepend(revAmt+' reviews');
        } else {
          $('.prod-review-info .rev-amount a').prepend(revAmt+' review');
        }

    }


  }, 2000);

  function calcHeaderHt() {
    $('.spr-review').each(function(index) {
      var titleHt = $(this).find('.spr-review-header-title').outerHeight();
      var titleHt = titleHt + 30;
      $(this).find('.spr-starratings').css('top', titleHt+'px');
    });
  }

  window.setTimeout(function () {
  	calcHeaderHt();
  }, 2000);

  $(window).on("resize",function(e){
    calcHeaderHt();
  });


  $('.prod-reviews .reviews-cta a').on('click', function (e) {
    var prodId = $('.prod-reviews .reviews-cta a').attr('data-product-id');
    var revPg = parseInt($('.prod-reviews .reviews-cta a').attr('data-page'));

    revPg = revPg + 1;

    $('.prod-reviews .reviews-cta a').remove();
    $('.prod-reviews .reviews-cta').prepend('<a href="#shopify-product-reviews" onclick="SPR.pageReviews(this)" data-product-id="'+prodId+'" data-page="'+revPg+'" class="btn">Read more reviews</a>');
  });

  $('.sabai-atc').on('click', function (e) {
    $('.cart-mini').addClass('cart-mini-open');
    $('body').addClass('minicart-open');
  });

  $('.reviews-header .newreviewtoggle').on('click', function (e) {
    e.preventDefault();
    $(this).parents('.reviews-header').next('#shopify-product-reviews').find('.spr-form').slideToggle();
  });

  if($('body.template-blog').length) {

    $('.blog-articles > .article').each(function(index) {
      $(this).find('a.article-rte-continuereading').append('<i></i>');

  	});

  }


  $('a[href="#refer-a-friend"]').on('click', function (e) {
    e.preventDefault();

    var loc = location.href;


    location.href = loc.replace(window.location.search,'') + "?tkbl_expand=true&tkbl_campaign_id=1246072";

  });



  if($('.pxs-announcement-bar').hasClass('topbar-enabled')) {
    $('body').addClass('has-topbar');
  }

  $(window).on("load",function(e){

    if($('.pxs-announcement-bar').hasClass('topbar-enabled')) {
      var topbarHt = $('.pxs-announcement-bar').outerHeight();

      $('body').addClass('topbar-'+topbarHt);

      $('.cart-mini-sidebar').css('top', topbarHt+'px');
      // $('#mobile-navigation').css('padding-top', (topbarHt+80)+'px');


    }

  });

  $(window).on("resize",function(e){

    if($('.pxs-announcement-bar').hasClass('topbar-enabled')) {
      var topbarHt = $('.pxs-announcement-bar').outerHeight();

      $('body').removeClass('topbar-47');
      $('body').removeClass('topbar-62');
      $('body').removeClass('topbar-77');

      $('body').addClass('topbar-'+topbarHt);

      $('.cart-mini-sidebar').css('top', topbarHt+'px');
      // $('#mobile-navigation').css('padding-top', (topbarHt+80)+'px');


    }

  });

  if($('[data-page="sustainability"]').length) {
    $(window).on("load resize",function(e){

      $('.illustration-spots .illus-spot').each(function(index) {
        var captHt = $(this).find('figcaption').outerHeight();
        var captHt = captHt + 20;
        $(this).css('padding-bottom', captHt+'px');
      });

    });
  }

  jQuery(document).ready(checkContainer);

  function checkContainer () {
    if($('[class*=" kl-private-reset-css-"]').is(':visible')){
      $('[class*=" kl-private-reset-css-"]').first().addClass('klaviyo-form');
    } else {
      setTimeout(checkContainer, 50);
    }
  }

};

_pc.tracking = function() {

  $('.pxs-newsletter-form-button').click(function(e) {
    window.pintrk?.('track', 'signup');
  });

  $(document).on('submit','form.minicartform',function(){
    var ids = [];
    $('.cart-mini-item').each(function(){
      var theids = $(this).attr('data-cart-mini-item');
      ids.push(theids);
    });

	var thePrice = $('.cart-mini-subtotal-value').text().replace('$', '');
    var theQuant =  $('.cart-mini-item').length;

    window.pintrk?.('track', 'checkout', {
      value: thePrice,
      order_quantity: theQuant,
      currency: 'USD',
      product_ids: ids
    },
    function(didInit, error) {
      if (!didInit) {
        console.error(error);
      }
    });

  });

  $('.product-submit').click(function(e) {
    var thePrice = $('.product-details-wrapper').find('.price > .money').text().replace('$', '');

    window.pintrk?.('track', 'AddToCart', {
       value: thePrice,
       order_quantity: 1,
       currency: 'USD'
     },
     function(didInit, error) {
       if (!didInit) {
        console.error(error);
       }
     });

  });



  if($('.page-product .seating-header').length) {
    if(window.location.href.indexOf("altpage") > -1) {
      $('.seating-header .chevlink').hide();
    }
  }
};

_pc.cartPage = function() {

  if($('body.template-cart').length) {

    $('.cart-item-quantity .btn-quantity--less').on('click',function (e) {
      e.preventDefault();

      var lineNo = $(this).attr('data-line');
      var currQuant = $(this).parents('.cart-quant').find('input.cart-item-quantity').val();
      var newQuant = parseInt(currQuant) - parseInt(1);

      if(newQuant == '0') {

        if($('.cart-mini-item[data-cart-mini-item]').length == 1) {
          // $('.cart-flyout-inner').html('<div class="text-center cart-empty"><h3>Your cart</h3><p class="cart--empty-message">Your cart is currently empty.</p><p class="cart--cookie-message">Enable cookies to use the shopping cart</p><p class="cart--continue-browsing">Continue browsing <a href="/pages/shop">here</a>.</p></div>');
          _updateItem(lineNo, newQuant);
        } else {
          _updateItem(lineNo, newQuant);
          $(this).parents('.cart-mini-item').remove();
          $('.cart-mini').find('.cart-mini-subtotal-value').text('$'+newCartPrice+'.00');

          $('.cart-mini-item').each(function(i) {
            var newNum = ++i;
            // $(this).attr('data-prodline', newNum);
            $(this).find('[data-line]').attr('data-line', newNum);
          });
        }
      } else {
        _updateItem(lineNo, newQuant);
        $(this).parents('.cart-quant').find('input.cart-item-quantity').val(newQuant);
      }

      window.setTimeout(function () {
        location.reload();
      }, 500);

    });

    $('.cart-item-quantity .btn-quantity--more').on('click',function (e) {
      e.preventDefault();

      var lineNo = $(this).attr('data-line');
      var currQuant = $(this).parents('.cart-quant').find('input.cart-item-quantity').val();
      var newQuant = parseInt(currQuant) + parseInt(1);

      _updateItem(lineNo, newQuant);
      $(this).parents('.cart-quant').find('input.cart-item-quantity').val(newQuant);

      window.setTimeout(function () {
        location.reload();
      }, 500);


    });

  }

};

_pc.cartClick = function() {


  $('.minicart-close').on('click', function (e) {
    e.preventDefault();

    $('.cart-mini').removeClass('cart-mini-open');
    $('body').removeClass('minicart-open');
    $('html').removeClass('scroll-locked');

  });

  $('.mini-cart-wrap').on('click', toggleCartRec);

  $('.product-submit').on('click',function (e) {

    if($(this).hasClass('swatch-packet-atc')) {

      var swNm =  $(this).parents('form').find('.current-variation option:selected').text();

      localStorage.setItem('packet', swNm);
    }

    window.setTimeout(function () {
      cartFlyoutUpdater();
    }, 750);

  });

  window.setTimeout(function () {
    cartFlyoutUpdater();
  }, 1200);
};


_pc.rebuy = function() {
  document.addEventListener('rebuy:cart.change', function(event) {
    CartJS.getCart();
    document.dispatchEvent(new CustomEvent('minicart-progress-banner:refresh'))

    const itemsCount = event.detail.cart.items().length;
    $('.main-header--tools-group .mini-cart-wrap .item-count').text(itemsCount).attr('data-cartcount', itemsCount);
    toggleCartRec();

    __cartMini__.refresh();
  });
};

function toggleCartRec() {
  const cartCount = $('.main-header--tools-group .mini-cart-wrap .item-count').text();

  if(cartCount == '0') {
    $('.cart-mini-rec').addClass('hide-rec');
  } else {
    $('.cart-mini-rec').removeClass('hide-rec');
  }
}


function cartFlyoutUpdater() {
  toggleCartRec();

  var cartCount =  $('.main-header--tools-group .mini-cart-wrap .item-count').text();
  $('.main-header--tools-group .mini-cart-wrap .item-count').attr('data-cartcount', cartCount);

  var updateGift = async function (giftUUID, dir = 'increase') {
    if (!giftUUID) return;

    const cartReponse = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await cartReponse.json();
    const giftItem = cart ? (cart.items || []).find(item => item.properties && item.properties['Is Gift'] === 'Yes' && item.properties._giftUUID === giftUUID) : null;
    const giftKey = giftItem.key
    const giftQuantity = giftItem.quantity
    const updateQuantity = dir === 'increase' ? giftQuantity + 1 : (dir === '0' ? 0 : giftQuantity - 1)
    const updateResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: giftKey, quantity: updateQuantity })
    })
    const updatedCart = await updateResponse.json()
    const updatedCartItem = updatedCart ? (updatedCart.items || []).find(item => item.key === giftKey) : null
    const $updatedGiftEl = $(`.js-cart-mini-item-gift[data-gift-uuid="${giftUUID}"]`);
    if (!updateQuantity) {
      $updatedGiftEl.length && $updatedGiftEl.remove()
    } else if (updatedCartItem && $updatedGiftEl.length) {
      const price = `<span>${Shopify.formatMoney(updatedCartItem.line_price, Shopify.moneyFormat)}</span>`
      const originPrice = updatedCartItem.original_line_price !== updatedCartItem.line_price
        ? `<s>${Shopify.formatMoney(updatedCartItem.original_line_price, Shopify.moneyFormat)}</s>`
        : ''
      $updatedGiftEl.find('.pn-total-line-item').html(`
        ${originPrice}
        ${price}
      `);
      $updatedGiftEl.find('.js-cart-item-input').val(updateQuantity)
    }
    $('.main-header--tools-group .mini-cart-wrap .item-count').text(updatedCart.item_count);
    $('.main-header--tools-group .mini-cart-wrap .item-count').attr('data-cartcount', updatedCart.item_count);
    return true;
  };

  $('.cart-mini .cart-mini-sidebar').delegate('.js-go-to-checkout', 'click', async function (e) {
    let formData = {
      note: $('.js-cart-text').val()
    };
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      window.location.href ='/checkout'
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  });
  $('.cart-mini .cart-mini-sidebar').on('click', '.cart-mini-item-remove', async function (e) {
    e.stopImmediatePropagation();
    const lineNo = $(e.target).closest('.cart-mini-item').find('[data-line]').attr('data-line');
    await _updateItem(lineNo, 0);
    const giftUUID = $(this).closest('[data-gift-uuid]').data('gift-uuid');
    if (giftUUID) {
      await updateGift(giftUUID, '0');
    }
    $(this).parents('.cart-mini-item').remove();

    if($('.cart-mini-item[data-cart-mini-item]').length == 0) {
      $('.cart-mini-footer').empty();
      $('.cart-mini-rec').addClass('hide-rec');
      $('.cart-mini-content').prepend('<div class="cart-mini-empty">You don’t have any items in your cart yet.</div>');
    } else {
      $('.cart-mini-rec').removeClass('hide-rec');
      $('.cart-mini-item').each(function(i) {
        var newNum = ++i;
        $(this).find('[data-line]').attr('data-line', newNum);
      });
    }
  });

  if(localStorage.getItem('packet')) {

	$('.cart-mini .cart-mini-item:first-child').find('.cartmini-item-title span').text(localStorage.getItem('packet'));
    localStorage.removeItem("packet");
  }
}

var bLazy = new Blazy({
  offset: 600,
  loadInvisible: true,
  success: function(ele){
    $(ele).parent().addClass('child-loaded');
    $.fn.matchHeight._update();
  }
});

// INITIALIZE
$(function() {
  _pc.set();
  _pc.scrolls();
  _pc.toggleNav();
  _pc.slick();
  _pc.accordion();
  _pc.scrollMagic();
  _pc.dropLists();
  _pc.formStuff();
  _pc.cartClick();
  _pc.misc();
  _pc.rebuy();
  _pc.tracking();
});

});
